import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import {
	ItButtonDirective,
	ItInputComponent,
	ItModalComponent,
} from 'design-angular-kit';
import { TranslateModule } from '@ngx-translate/core';
import { IterlexService } from '../iterlex.service';
import { DossierComponent } from '../dossier/dossier.component';
import type { Authority } from '../interfaces/authority';
import type { StagingArea } from '../interfaces/staging-area';

@Component({
	selector: 'app-staging-area-page',
	imports: [
		FormsModule,
		ItButtonDirective,
		ItInputComponent,
		ItModalComponent,
		TranslateModule,
		DossierComponent,
	],
	templateUrl: './staging-area-page.component.html',
	styleUrl: './staging-area-page.component.scss',
})
export class StagingAreaPageComponent implements OnInit {
	private iterlexService = inject(IterlexService);

	@ViewChild('importedStagingAreaModal')
	importedStagingAreaModal!: ItModalComponent;
	authorities: Authority[] = [];
	stagingAreas: StagingArea[] = [];
	currentStagingArea?: StagingArea;
	progressRemoveStagingAreaId = Number.NaN;
	progressImportStagingAreaId = Number.NaN;
	ngOnInit(): void {
		this.iterlexService.getAuthorities().subscribe((authorities) => {
			this.authorities = authorities;
		});
		this.loadStagingArea();
	}
	findBodyIfPresent(authorityId: string) {
		const authorityChildren =
			this.authorities.find((authority) => authority.id == authorityId)
				?.children ?? [];
		if (authorityChildren.length > 0) {
			return authorityChildren[0].id;
		}
		return authorityId;
	}
	loadStagingArea() {
		const params = new HttpParams()
			.append('authority', 'consiglio')
			.append('body', 'presidenzaAssemblea');
		this.iterlexService
			.getStagingAreas(params)
			.subscribe((paginatedStagingAreas) => {
				this.stagingAreas = paginatedStagingAreas.value;
			});
	}
	removeStagingArea(stagingAreaId: number) {
		this.progressRemoveStagingAreaId = stagingAreaId;
		this.iterlexService
			.deleteStagingArea(
				'consiglio',
				'presidenzaAssemblea',
				stagingAreaId,
			)
			.subscribe({
				next: () => {
					this.loadStagingArea();
				},
				complete: () => {
					this.progressRemoveStagingAreaId = Number.NaN;
				},
			});
	}
	onImportStagingAreaSubmit(form: NgForm) {
		if (form.valid) {
			this.progressImportStagingAreaId = this.currentStagingArea!.id;
			this.iterlexService
				.importStagingArea(
					this.currentStagingArea!.recipientAuthorityName,
					this.findBodyIfPresent(
						this.currentStagingArea!.recipientAuthorityName,
					),
					this.currentStagingArea!.id,
					this.currentStagingArea!.dossier.workUri,
					form.value.newNumber,
					form.value.newDate,
					this.currentStagingArea!.recipientAuthorityName ==
						'pubblicazione'
						? 'verificaLinguistica'
						: 'condivisione' +
								this.currentStagingArea!.senderAuthorityName.charAt(
									0,
								).toUpperCase() +
								this.currentStagingArea!.senderAuthorityName.slice(
									1,
								),
					this.currentStagingArea!.recipientAuthorityName ==
						'pubblicazione'
						? 'verificaFinale'
						: 'inIngresso',
				)
				.subscribe({
					next: () => {
						this.importedStagingAreaModal.toggle();
						this.loadStagingArea();
					},
					complete: () => {
						this.progressImportStagingAreaId = Number.NaN;
					},
				});
		}
	}
}
